/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
import React from 'react';
import './index.less';
import closeIcon from '@assets/close-icon.png';

export interface PopupModelProps {
  visible?: boolean;
  haveCloseIcon?: boolean;// 是否显示关闭按钮
  // 提示文案
  popupTitle?: string | React.ReactNode;
  leftBtnText?: string | React.ReactNode;
  rightBtnText?: string | React.ReactNode;
  leftBtnFun?: () => void;
  rightBtnFun?: () => void;
  close?: () => void;
  zIndex?: number;
  content?:  string | React.ReactNode;
}

export default function PopupModel(props: PopupModelProps) {
  const {
    visible = true,
    popupTitle = '',
    leftBtnText = '',
    rightBtnText = '',
    leftBtnFun = () => {},
    rightBtnFun = () => {},
    close,
    zIndex = 99
  } = props;
  if(!visible) {
    return null;
  }
  return (
    <div className="popup-model" style={{zIndex: zIndex}}>
      <div className="popup-mask" onClick={close}></div>
      <div className="content-box">
        <div className="content-title">
          {popupTitle}
        </div>
        <div className="popupModel-content">
          {props.content}
        </div>
        <div className="operation-boxs">
          {leftBtnText && (
            <div onClick={()=>leftBtnFun()} className={`${rightBtnText ? 'left-btn' : 'left-btn-singer'}`}>
              <p>{props.leftBtnText}</p>
            </div>
          )}
          {rightBtnText && (
            <div onClick={rightBtnFun} className="right-btn">
              <p>{props.rightBtnText}</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
